import type { INotification } from "@bbj-types/notification";
import { useSuspense } from "@root/api/tools/axios";
import { useCallback } from "react";
import { axios, axiosNotificationInstance } from "./axios";

export const useGetNotifications = () => {
  const [state, execute, cancel] = axios<INotification[], void, unknown>(
    {
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(() => {
    return execute({
      url: "",
    });
  }, [execute]);

  return [state, callback, cancel] as const;
};

export const useGetNotificationsSuspense = () => {
  return useSuspense(
    () =>
      axiosNotificationInstance.get<INotification[]>("/", {
        withCredentials: true,
      }),
    []
  );
};
